var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pageTitle", attrs: { title: _vm.getPageTitle } },
    [
      _c("p", {
        staticClass: "header",
        domProps: { textContent: _vm._s(_vm.title) },
      }),
      _c("p", { staticClass: "h-p" }, [
        _vm.headerTitle
          ? _c("span", { domProps: { textContent: _vm._s(_vm.headerTitle) } })
          : _vm._e(),
        _vm.text
          ? _c("span", {
              staticClass: "h-span",
              domProps: { textContent: _vm._s(_vm.text) },
            })
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }